import { ErrorCode, errorCodeOf, getCodeSpec } from './chunk-HCZGW64N.js';

// src/i18n/index.ts
var ERROR_I18N_NAMESPACE = "errors";
function buildErrorI18nResources() {
  const out = {};
  for (const spec of Object.values(ErrorCode)) {
    out[spec.code] = {
      description: spec.description,
      userAction: spec.userAction,
      documentationUrl: spec.documentationUrl
    };
  }
  return out;
}
function registerErrorMessages(i18n, lng = "en") {
  i18n.addResourceBundle(lng, ERROR_I18N_NAMESPACE, buildErrorI18nResources(), true, true);
}
function messageForError(error, i18n) {
  const code = errorCodeOf(error);
  if (code && i18n) {
    const descKey = `${ERROR_I18N_NAMESPACE}:${code}.description`;
    const actionKey = `${ERROR_I18N_NAMESPACE}:${code}.userAction`;
    const exists = i18n.exists ? i18n.exists(descKey) : true;
    if (exists) {
      return { description: i18n.t(descKey), userAction: i18n.t(actionKey) };
    }
  }
  if (code) {
    const spec = getCodeSpec(code);
    if (spec) return { description: spec.description, userAction: spec.userAction };
  }
  return { description: error.message };
}

export { ERROR_I18N_NAMESPACE, buildErrorI18nResources, messageForError, registerErrorMessages };
//# sourceMappingURL=chunk-23HJDEPB.js.map
//# sourceMappingURL=chunk-23HJDEPB.js.map